import React, { useState } from 'react';

const SquareRootTable = () => {
  const [startNumber, setStartNumber] = useState(0.0);
  const [squareRootTable, setSquareRootTable] = useState([]);

  const calculateSquareRootTable = () => {
    if (startNumber < 0.0 || startNumber > 9.9) {
      alert("Please enter a valid number between 0.0 and 9.9.");
      return;
    }

    const table = [];
    for (let i = 0; i <= 9; i++) {
      const currentNumber = parseFloat(startNumber) + i / 10;
      const squareRootValue = Math.sqrt(currentNumber).toFixed(4);
      const nextSquareRootValue = Math.sqrt(currentNumber + 0.1).toFixed(4);
      const meanDifference = (nextSquareRootValue - squareRootValue).toFixed(4);
      table.push({
        currentNumber: currentNumber.toFixed(1),
        squareRootValue,
        meanDifference,
      });
    }
    setSquareRootTable(table);
  };

  return (
    <div>
      <h2>Square Root Table Generator</h2>
      <label htmlFor="startNumber">Enter a number (0.0 - 9.9): </label>
      <input
        type="number"
        id="startNumber"
        min="0.0"
        max="9.9"
        step="0.1"
        value={startNumber}
        onChange={(e) => setStartNumber(parseFloat(e.target.value))}
      />
      <button onClick={calculateSquareRootTable}>Generate Table</button>

      {squareRootTable.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Number</th>
              <th>Square Root</th>
              <th>Mean Difference</th>
            </tr>
          </thead>
          <tbody>
            {squareRootTable.map((row, index) => (
              <tr key={index}>
                <td>{row.currentNumber}</td>
                <td>{row.squareRootValue}</td>
                <td>{row.meanDifference}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SquareRootTable;
